import { create } from 'zustand';
import { StatsMap } from '@/workers/viewAnalysis.worker';
import { HorizonContext } from '@/types/horizonContext';

export interface ViewScoreSettingsSnapshot {
	horizonContexts: HorizonContext[];
	isBeyondHorizonEnabled: boolean;
}

interface ViewScoreStore {
	viewData: Record<string, Record<string, StatsMap>>;
	setViewData: (data: Record<string, Record<string, StatsMap>>) => void;
	viewSettingsByPoint: Record<string, ViewScoreSettingsSnapshot>;
	setViewSettingsForPoint: (pointKey: string, settings: ViewScoreSettingsSnapshot) => void;
	setViewSettingsByPoint: (settingsByPoint: Record<string, ViewScoreSettingsSnapshot>) => void;
	viewScoreProgress: number;
	setViewScoreProgress: (progress: number) => void;
	horizonContexts: HorizonContext[];
	setHorizonContexts: (contexts: HorizonContext[]) => void;
	isBeyondHorizonEnabled: boolean;
	setIsBeyondHorizonEnabled: (enabled: boolean) => void;
}

export const useViewScoreStore = create<ViewScoreStore>((set) => {
	return {
		viewData: {} as Record<string, Record<string, StatsMap>>,
		setViewData: (data) => set(() => ({ viewData: data })),
		viewSettingsByPoint: {},
		setViewSettingsForPoint: (pointKey, settings) =>
			set((state) => ({
				viewSettingsByPoint: {
					...state.viewSettingsByPoint,
					[pointKey]: settings,
				},
			})),
		setViewSettingsByPoint: (settingsByPoint) => set(() => ({ viewSettingsByPoint: settingsByPoint })),
		viewScoreProgress: 0,
		setViewScoreProgress: (progress) => set(() => ({ viewScoreProgress: progress })),
		horizonContexts: [],
		setHorizonContexts: (contexts) => set(() => ({ horizonContexts: contexts })),
		isBeyondHorizonEnabled: false,
		setIsBeyondHorizonEnabled: (enabled) => set(() => ({ isBeyondHorizonEnabled: enabled })),
	};
});
